import { assetFragment } from '@arriere/modules/fragments/asset'

export const hotelBasicInfoFragment = {
  id: true,
  name: true,
  thumbnail: {
    id: true,
    url: true,
  },
}

export const hotelDetailsFragment = {
  ...hotelBasicInfoFragment,
  description: true,
  logo: {
    ...assetFragment,
  },
  address: {
    address: true,
    zipCode: true,
    city: true,
    stateId: true,
    countryCode: true,
    state: {
      name: true,
    },
    region: {
      id: true,
      name: true,
    },
  },
  latitude: true,
  longitude: true,
}
